const faqArray = [
    {
        title: 'Is Medical Marijuanana legal in Illinois?',
        desc: 'Yes if you qualify for the medical conditions specified on by the State of Illinois, EarthMed can provide you medical cannabis'
    },
    {
        title: 'Can patients grow cannabis at home?',
        desc: 'No. Patients in Illinois are not permitted to grow their own cannabis. While some other states allow the cultivation of plants by patients, Illinois does not.'
    },
    {
        title: 'What are the possession limits?',
        desc: 'Patients are able to access 2.5 ounces of cannabis every 14 days through their registered dispensary.'
    },
    {
        title: 'Is it legal to drive after medicating with cannabis?',
        desc: 'No. Consuming cannabis and operating a motor vehicle is illegal under all circumstances.'
    },
    {
        title: 'Can I share my cannabis?',
        desc: 'No. As a patient, it is illegal gift, give, or donate any form of medical cannabis to anyone else. Medical cannabis products are only available to licensed patients and is only legally obtained through a licensed state dispensary.'
    },
    {
        title: 'Can I consume medical cannabis publicly?',
        desc: 'No. Smoking medical cannabis is prohibited anywhere smoking tobacco is via the Smoke-Free Illinois Act. Also, it is not recommended to be publicly intoxicated on medical marijuana.'
    },
    {
        title: 'Can I travel outside of Illinois with my medical cannabis?',
        desc: 'No. Traveling outside of the state with medical cannabis is illegal and punishable by law .'
    },
    {
        title: 'How do consumption methods differ in effect?',
        desc: 'Medical cannabis effects vary depending upon how they are consumed. For example, cannabis inhalation methods provide more rapid onset, while oral consumption and ingestion methods produce more psychoactive effects that take longer to feel. Our Earthmed medical cannabis professionals are very well versed in this topic and can answer any detailed questions you may have in person.'
    },
    {
        title: 'How should I select my medicine?',
        desc: 'This is where our Earthmed team can help you. Our medical cannabis experts listen to your needs and address them on a patient by patient basis. We are extremely knowledgeable and help guide you through this process every step of the way. Since this process is vastly different for each patient, typically a patient will start by deciding whether they are looking for a Sativa, Indica or Hybrid strain. The effects produced by each strain of medical cannabis will differ depending upon the cannabinoid and terpene profiles. This is something that the professionals at Earthmed are happy to assist you with.'
    },
    {
        title: 'When will you be opening?',
        desc: 'We are currently open!'
    },
    {
        title: 'Who is EarthMed?',
        desc: 'EarthMed is a corporation that believes in providing compassionate medical marijuana care for the community. We want to help you.'
    },
    {
        title: 'Where are you located?',
        desc: 'We are located at 852 Westgate Dr, Addison IL 60101.'
    },
    {
        title: 'How do I get my medical marijuana card?',
        desc: 'There are several steps you need to take, please see Get Your Medical Marijuana Card to get started.'
    },
    {
        title: 'When will recreational marijuana be available in Illinois?',
        desc: 'Recreational marijuana will be available in Illinois starting on January 1, 2020. Earthmed will have both medical and recreational cannabis available  at it’s Addison location. Earthmed will also be opening a soon to be disclosed second location that sells recreational marijuana.'
    },
]

export default faqArray;